export default __webpack_public_path__ + "static/media/show-in-doc.abc83ada.svg";